// push.js — Web Push côté client (notifications hors-app).
// Le service worker /sw.js (déjà enregistré pour la PWA) gère les événements push/notificationclick.
// Ici : détection du support, abonnement (PushManager) et écriture de la subscription dans le
// storage Nakama (collection vg_push, clé sub) pour que le backend puisse notifier ce joueur.
import { nakamaAuth } from './nakamaAuth';

const BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

export function pushSupported() {
  return typeof navigator !== 'undefined' && 'serviceWorker' in navigator
    && typeof window !== 'undefined' && 'PushManager' in window && 'Notification' in window;
}
export function pushPermission() { return pushSupported() ? Notification.permission : 'unsupported'; }

function urlB64ToUint8(b64) {
  const pad = '='.repeat((4 - (b64.length % 4)) % 4);
  const s = (b64 + pad).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(s);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

async function vapidKey() {
  if (!BASE) return '';
  try { const r = await fetch(`${BASE}/push/vapid`); const d = await r.json(); return d.configured ? d.publicKey : ''; }
  catch { return ''; }
}

// Abonne le navigateur et enregistre la subscription dans Nakama. Suppose la permission accordée.
async function subscribeAndStore(auth) {
  const key = await vapidKey();
  if (!key) return { ok: false, reason: 'unconfigured' };
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlB64ToUint8(key) });
  }
  try { await auth.storageWrite('vg_push', 'sub', JSON.parse(JSON.stringify(sub))); } catch { /* */ }
  return { ok: true };
}

// Action utilisateur : demande la permission puis s'abonne (bouton « activer les notifications »).
export async function enablePush(auth) {
  if (!pushSupported()) return { ok: false, reason: 'unsupported' };
  if (!auth || !auth.session || auth.session._localGuest) return { ok: false, reason: 'guest' };
  let perm = Notification.permission;
  if (perm === 'default') perm = await Notification.requestPermission();
  if (perm !== 'granted') return { ok: false, reason: perm === 'denied' ? 'denied' : 'dismissed' };
  try { return await subscribeAndStore(auth); } catch { return { ok: false, reason: 'error' }; }
}

// Silencieux : si la permission est DÉJÀ accordée, (ré)abonne au login pour garder la sub fraîche.
export async function syncPush(auth) {
  if (!pushSupported() || Notification.permission !== 'granted') return;
  if (!auth || !auth.session || auth.session._localGuest) return;
  try { await subscribeAndStore(auth); } catch { /* */ }
}

// Déclenche une push vers un destinataire (l'expéditeur connecté ; marche si le destinataire est hors-app).
// payload : { to, type: 'friend_request' | 'room_invite', game? }
export async function pushNotify(payload) {
  const auth = nakamaAuth;
  if (!BASE || !auth || !auth.session || auth.session._localGuest || !payload || !payload.to) return;
  try {
    await fetch(`${BASE}/push/notify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${auth.session.token}` },
      body: JSON.stringify(payload),
    });
  } catch { /* best-effort */ }
}
